import {
  DataTableSource,
  type DataTablePageReq,
  type DataTablePageResp,
} from "@carbon6/c6-frontend-design";
import { createEvalPolicyTableRows, type EvalPolicyGroupRow } from "./EvalPolicyTableRow";
import type { EvaluationTargetPolicy } from "./evaluationTargetPolicy";

// 평가 대상 policy 는 목록 표의 선택에서 그대로 가져온 스냅샷이라 조회하지 않는다. 요청 page/size
// 는 무시하고 한 페이지로 합친다. 표도 페이저를 그리지 않는다.
export class EvalPolicyTableSource extends DataTableSource<EvalPolicyGroupRow> {
  constructor(private readonly policies: readonly EvaluationTargetPolicy[]) {
    super();
  }

  protected override onPage(req: DataTablePageReq): Promise<DataTablePageResp<EvalPolicyGroupRow>> {
    const rows = createEvalPolicyTableRows(this.policies);
    return Promise.resolve({
      rows,
      total: rows.length,
      page: 1,
      size: Math.max(rows.length, req.size),
    });
  }
}
